var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "computer_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "computer_svg__ds",
    x1: 74,
    y1: 182.79,
    x2: 356,
    y2: 182.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m349,257.53H81c-3.87,0-7-3.13-7-7V115.04c0-3.87,3.13-7,7-7h268c3.87,0,7,3.13,7,7v135.49c0,3.87-3.13,7-7,7Zm-261-14h254v-121.49H88v121.49Z",
    style: {
      fill: "url(#computer_svg__ds)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.99,346.93H28c-2.46,0-4.74-1.29-6.01-3.41l-13.97-23.35c-.07-.12-.14-.23-.2-.35-.83-1.56-1.02-3.3-.63-4.91h0s0,0,0-.01c0,0,0,0,0,0,0,0,0,0,0,0,.03-.12.06-.23.09-.35h0s0-.01,0-.02c0,0,0,0,0,0,0,0,0,0,0,0,.35-1.16,1-2.23,1.92-3.09l39.82-38.87V90.07c0-3.87,3.13-7,7-7h317.93c3.87,0,7,3.13,7,7v182.48l39.82,38.87c.89.83,1.53,1.87,1.89,3,0,0,0,0,0,0s0,0,0,0c.06.19.11.38.15.57h0s0,0,0,.01c0,0,0,0,0,.01h0c.35,1.58.15,3.28-.66,4.8-.06.12-.13.24-.2.36l-13.98,23.35c-1.26,2.11-3.54,3.4-6.01,3.4Zm-370.02-14h366.05l5.63-9.4H26.35l5.62,9.4Zm-.77-23.4h367.61l-27.69-27.02-312.74.49-27.18,26.53Zm31.84-41.03h303.93V97.07H63.04v171.43Z",
    style: {
      fill: "#f7f7f7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.d56da3ff7301c973c648a04a3d9e2a84.svg";
export { ForwardRef as ReactComponent };